import { Star } from 'lucide-react';
import { useState } from 'react';

const ReviewCard = ({ review }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <>
      <div
        data-testid={`review-card-${review.id}`}
        className="p-8 border border-white/10 bg-neutral-900/20 hover:bg-neutral-900/40 transition-colors"
      >
        {/* Stars */}
        <div className="flex gap-1 mb-4">
          {[...Array(5)].map((_, i) => (
            <Star
              key={i}
              className={`w-4 h-4 ${
                i < review.rating
                  ? 'fill-cyan-400 text-cyan-400'
                  : 'text-neutral-700'
              }`}
            />
          ))}
        </div>

        {/* Comment */}
        <p className="text-neutral-300 leading-relaxed mb-4">
          "{review.comment}"
        </p>

        {/* Review Images */}
        {review.images && review.images.length > 0 && (
          <div className="flex gap-2 mb-6 flex-wrap">
            {review.images.map((img, index) => (
              <button
                key={img.url || `review-img-${index}`}
                onClick={() => setSelectedImage(img.url)}
                className="w-16 h-16 overflow-hidden border border-white/10 hover:border-cyan-400/50 transition-colors"
              >
                <img
                  src={img.url}
                  alt={img.alt || 'Review photo'}
                  className="w-full h-full object-cover"
                />
              </button>
            ))}
          </div>
        )}

        {/* Author */}
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-cyan-400/20 rounded-full flex items-center justify-center">
            <span className="text-cyan-400 font-heading font-bold">
              {review.customer_name.charAt(0)}
            </span>
          </div>
          <div>
            <p className="font-heading text-sm font-semibold text-white">
              {review.customer_name}
            </p>
            <p className="text-xs text-neutral-500 font-mono uppercase tracking-widest">
              Verified Buyer
            </p>
          </div>
        </div>
      </div>

      {/* Image Lightbox */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/90"
          onClick={() => setSelectedImage(null)}
        >
          <img
            src={selectedImage}
            alt="Review photo enlarged"
            className="max-w-full max-h-full object-contain"
          />
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-4 right-4 text-white/70 hover:text-white text-4xl font-light"
          >
            ×
          </button>
        </div>
      )}
    </>
  );
};

export default ReviewCard;
